module.exports = __webpack_public_path__ + "static/fist_emoji-002589f8feaebea741dbd6e72ca85ab1.svg";